import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"

type PropTypes = {
  mapCode: string
}

const MapIframe = styled.iframe`
  border: 0.5px solid ${colors("blue", "xdk")};
  background-color: ${colors("blue", "xdk")};
  width: 100%;
  flex-grow: 0;
  margin-bottom: 20px;
  @media screen and (min-width: 1500px) {
    width: auto;
    flex-grow: 1;
    margin-right: 50px;
  })
`

const HomeMap: React.FC<PropTypes> = ({ mapCode }) => {
  let mapSrc = ""

  if (mapCode) {
    mapSrc = mapCode.replace('<iframe src="', "")
    mapSrc.replace(
      '" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
      ""
    )
  }

  return (
    <MapIframe
      title="Facility map"
      src={mapSrc}
      width="805"
      height="445"
      allowfullscreen
      loading="lazy"
      frameborder="0"
    ></MapIframe>
  )
}

export default HomeMap
